import { getCookie, deleteCookie } from 'utils/storage';

let setupData = {
    bearerAccessToken: '',
};

export const setup = (data) => {
    setupData = { ...setupData, ...data };
};

let timer;

const resetTimer = () => {
    if (timer) clearTimeout(timer);
};

const logoutEvents = [
    'mousemove',
    'mousedown',
    'touchstart',
    'click',
    'wheel',
    'keydown',
];

let interval;

const resetInterval = () => {
    if (interval) {
        clearInterval(interval);
    }
};

export const logout = (navigate) => {
    resetInterval();
    deleteCookie('sinvest_jwt_token');
    deleteCookie('client_id');
    deleteCookie('portfolio_id');
    deleteCookie('expiryDate');
    deleteCookie('expiryInSeconds');
    logoutEvents.forEach((item) => {
        window.removeEventListener(item, resetTimer);
    });

    navigate('/login');
};

export const autoLogout = (navigate) => {
    const expiry = decodeURI(getCookie('expiryInSeconds')) * 1000;

    const handleLogoutTimer = async () => {
        if (decodeURI(getCookie('expiryInSeconds'))) {
            timer = setTimeout(() => {
                logout(navigate);
            }, expiry);
        }
    };

    const init = () => {
        logoutEvents.forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    };

    init();
};

export const renewToken = async (navigate, callback) => {
    const sessionToken = decodeURI(getCookie('sinvest_jwt_token'));
    const sessionMemberAccessToken = sessionToken.split(' ')[1];

    const contactId = decodeURI(getCookie('client_id'));

    const respRenew = await fetch(
        `${global?.AppConfig?.CUSTOM_URL_SUFFIX}/v1.0/contacts/${contactId}/authentication/tokens/renew`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                accessToken: sessionMemberAccessToken,
            }),
        },

    );

    const renew = await respRenew.json();

    if (renew?.result === 'Success') {
        const bearerAccessToken = `Bearer ${renew.session.jwtAccessToken}`;

        document.cookie = `sinvest_jwt_token=${bearerAccessToken};secure`;
        document.cookie = `expiryDate=${renew.session.expiryDate};secure`;
        document.cookie = `expiryInSeconds=${renew.session.expiryInSeconds};secure`;
        if (callback) {
            await callback();
        }
    } else {
        logout(navigate);
    }
};

export const autoRenew = (navigate) => {
    const expiryDate = decodeURI(getCookie('expiryDate'));

    if (decodeURI(getCookie('expiryDate')) && decodeURI(getCookie('sinvest_jwt_token'))
    && ((new Date(expiryDate).getTime() - new Date().getTime() - 10000)) > 0) {
        resetInterval();
        interval = setInterval(async () => {
            renewToken(navigate);
        }, new Date(expiryDate).getTime() - new Date().getTime() - 10000);
    } else {
        resetInterval();
    }
};
